import Settings from '@/components/views/auth/Settings'
import Login from '@/components/views/auth/Login'
import ForgotPassword from '@/components/views/auth/ForgotPassword'
import QuickSignUp from '@/components/views/user-quick-sign-up/QuickSignUp'
import QuickPayment from '@/components/views/user-quick-sign-up/QuickPayment'

const SignUp = () => {
  if (process.env.GAME_ID === 52) {
    return import('@/components/views/sign-up/52/SignUp')
  }
  if (process.env.GAME_ID === 68) {
    return import('@/components/views/sign-up/68/SignUp')
  }
  if (process.env.GAME_ID === 69) {
    return import('@/components/views/sign-up/69/SignUp')
  }
  if (process.env.GAME_ID === 62) {
    return import('@/components/views/sign-up/62/SignUp')
  }
  return import('@/components/views/sign-up/SignUp')
}
const enabledSignUp = process.env.SIGNUP

const app = process.env.APP_NAME
export default [
  {
    path: '/user/payment',
    name: 'QuickPayment',
    component: QuickPayment,
    meta: {auth: true, title: `${app}: License Fee`, pageTitle: 'License Fee', layout: 'standard'}
  }, enabledSignUp && {
    path: '/user/sign-up/:step',
    name: 'QuickSignUp',
    component: QuickSignUp,
    meta: {auth: undefined, title: `${app}: Sign Up`, pageTitle: 'Sign Up', layout: 'standard'}
  }, enabledSignUp && {
    path: '/sign-up/:step',
    name: 'SignUp',
    component: SignUp,
    meta: {auth: undefined, title: `${app}: Sign Up`, pageTitle: 'Sign Up', layout: 'standard'}
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {auth: false, title: `${app}: Login`, layout: 'standard'}
  }, {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {auth: false, title: `${app}: Forgot password`, pageTitle: 'Forgot password', layout: 'standard'}
  }, {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {auth: true, title: `${app}: My settings`, pageTitle: 'My Settings', layout: 'standard'}
  }
].filter(Boolean)



// WEBPACK FOOTER //
// ./src/router/auth-routes.js